import React from "react";
//#region redux
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { InvoiceSettingsWizardStepProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { WizardSection } from "components/common/wintForms";
import PaymentSettingsSection from "./paymentSettingsSection";
import DisplaySettingsSection from "./displaySettingsSection";
import SendSettingsSection from "./sendSettingsSection";
import ReminderSettingsSection from "./reminderSettingsSection";
//#endregion

const InvoiceSettingsWizardStep: React.FC<InvoiceSettingsWizardStepProps> = ({
  connect,
  submitted,
  wizardProps,
  invoiceSettings,
}) => {
  const sendSettingsProps = connect("sendOptions");
  const reminderSettingsProps = connect("reminderSettings");
  const paymentSettingsProps = connect("paymentSettings");
  const displaySettingsProps = connect("displaySettings");

  return (
    <WizardSection
      header={TranslationKeys.Customer.Billing}
      submitted={submitted}
      hasErrors={
        sendSettingsProps.error ||
        reminderSettingsProps.error ||
        paymentSettingsProps.error ||
        displaySettingsProps.error
      }
      wizardProps={wizardProps}
    >
      <SendSettingsSection connect={connect} invoiceSettings={invoiceSettings} />
      <ReminderSettingsSection connect={connect} invoiceSettings={invoiceSettings} />
      <PaymentSettingsSection connect={connect} />
      <DisplaySettingsSection connect={connect} />
    </WizardSection>
  );
};

export default InvoiceSettingsWizardStep;
